import { render, staticRenderFns } from "./cus_btn.vue?vue&type=template&id=578b5afe&scoped=true"
import script from "./cus_btn.vue?vue&type=script&lang=js"
export * from "./cus_btn.vue?vue&type=script&lang=js"
import style0 from "./cus_btn.vue?vue&type=style&index=0&id=578b5afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b5afe",
  null
  
)

export default component.exports